import { Outlet, Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "../css/admin.css";

// import SocketContext from "../pages/socket-context";
import UsersMsgs from "../pages/socket-users-msg";

// const Layout = () => {
const Layout = ({socket}) => {

    // const [roomUsers, setRoomUsers] = useState([]);
    // const [messagesRecieved, setMessagesReceived] = useState([]);

    // useEffect(() => {
    //     socket.on('chatroom_users', (data) => {
    //       console.log('chatroom_users are---', data);
    //       setRoomUsers(data);
    //     });
    
    //     return () => socket.off('chatroom_users');
    // }, [socket]);

    // useEffect(() => {
    //     socket.on('receive_message', (data) => {
    //         console.log("receive_message-->>", data);
    //         setMessagesReceived((state) => [
    //             ...state,
    //             {
    //             message: data.message,
    //             username: data.username,
    //             __createdtime__: data.__createdtime__,
    //             },
    //         ]);
    //     });
    
    //     return () => socket.off('receive_message');
    // }, [socket]);

    useEffect(() => {
        setShowContent(true);
    }, []);

    const [openMenu, setOpenMenu] = useState(true);
    const [showContent, setShowContent] = useState(false);
    const toggleMenu = () => {
        setOpenMenu(!openMenu);
    };

    return (
        <>
            <nav className="sb-topnav navbar navbar-expand navbar-dark bg-dark justify-content-between">
                <div className="d-flex align-items-start">
                    <Link className="navbar-brand ps-3" to="/secure/dashboard" title="TMS">TMS</Link>
                    <button className="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0 mt-1" id="sidebarToggle" onClick={toggleMenu} href="#!">
                        <i className="fas fa-bars"></i>
                    </button>
                </div>
                <ul className="navbar-nav ms-auto ms-md-0 me-3 me-lg-4">
                    <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" id="navbarDropdown" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false"><i className="fas fa-user fa-fw"></i></a>
                        <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                            <li><Link className="dropdown-item" href="#!"><i className="fa-solid fa-gear"></i> Settings</Link></li>
                            <li><Link to="/logoutAdmin" className="dropdown-item"><i className="fa-solid fa-right-from-bracket"></i> Logout</Link></li>
                        </ul>
                    </li>
                </ul>
            </nav>

            <div id="layoutSidenav">
                {openMenu ? (
                <div id="layoutSidenav_nav">
                    <nav className="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
                        <div className="sb-sidenav-menu">
                            <div className="nav">
                                <div className="sb-sidenav-menu-heading">Core</div>
                                <Link className="nav-link" to="/secure/dashboard">
                                    <div className="sb-nav-link-icon"><i className="fas fa-tachometer-alt"></i></div>
                                    Dashboard
                                </Link>
                                <div className="sb-sidenav-menu-heading">Interface</div>

                                <a className="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseLayouts" aria-expanded="false" aria-controls="collapseLayouts">
                                    <div className="sb-nav-link-icon"><i className="fa-solid fa-users"></i></div>
                                    Users
                                    <div className="sb-sidenav-collapse-arrow"><i className="fas fa-angle-down"></i></div>
                                </a>
                                <div className="collapse" id="collapseLayouts" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                                    <nav className="sb-sidenav-menu-nested nav">
                                        <Link to="/secure/civil-servants" className="nav-link"><i className="fa-solid fa-graduation-cap"></i> Civil Servants</Link>
                                        <Link to="/secure/mentors" className="nav-link"><i className="fa-solid fa-person-chalkboard"></i> Mentors</Link>
                                    </nav>
                                </div>
                                
                                <a className="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseLayouts1" aria-expanded="false" aria-controls="collapseLayouts1">
                                    <div className="sb-nav-link-icon"><i className="fas fa-columns"></i></div>
                                    Assignments
                                    <div className="sb-sidenav-collapse-arrow"><i className="fas fa-angle-down"></i></div>
                                </a>
                                <div className="collapse" id="collapseLayouts1" aria-labelledby="headingTwo" data-bs-parent="#sidenavAccordion">
                                    <nav className="sb-sidenav-menu-nested nav">
                                        <Link to="/secure/assignments" className="nav-link"> <i class="fa-solid fa-laptop-file"></i>  Assignments</Link>
                                    </nav>
                                </div> 

                                <a className="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseLayouts2" aria-expanded="false" aria-controls="collapseLayouts">
                                    <div className="sb-nav-link-icon"><i class="fa-solid fa-clipboard-user"></i></div>
                                    Attendance
                                    <div className="sb-sidenav-collapse-arrow"><i className="fas fa-angle-down"></i></div>
                                </a>
                                <div className="collapse" id="collapseLayouts2" aria-labelledby="headingTwo" data-bs-parent="#sidenavAccordion">
                                    <nav className="sb-sidenav-menu-nested nav">
                                        <Link to="/secure/attendance/add-attendance" className="nav-link"><i class="fa-solid fa-address-card"></i> Add Attendance</Link>
                                    </nav>
                                </div>

                                <a className="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#collapseLayouts3" aria-expanded="false" aria-controls="collapseLayouts3">
                                    <div className="sb-nav-link-icon"><i className="fas fa-message"></i></div>
                                    Messages
                                    <div className="sb-sidenav-collapse-arrow"><i className="fas fa-angle-down"></i></div>
                                </a>
                                <div className="collapse" id="collapseLayouts3" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                                    <nav className="sb-sidenav-menu-nested nav">
                                        <Link to="./messages" className="nav-link">All Messages</Link>
                                        <Link to="./messages/join-room" className="nav-link">Online Chat</Link>
                                    </nav>
                                </div>
                            </div>
                        </div>
                        <div className="sb-sidenav-footer">
                            <div className="small">Logged in as:</div>
                            admin@yopmail.com
                        </div>
                    </nav>
                </div>
                ) : null}
                <div id="layoutSidenav_content">
                    <UsersMsgs socket={socket} />

                    {/* <Outlet /> */}
                    {/* <SocketContext.Provider value={{roomUsers:roomUsers, messagesRecieved:messagesRecieved}}> */}

                    {/* <SocketContext.Provider value={{roomUsers:roomUsers, messagesRecieved:messagesRecieved, setMessagesReceived:setMessagesReceived}}>
                        <Outlet />
                    </SocketContext.Provider> */}

                    <footer className="py-4 bg-light mt-auto">
                        <div className="container-fluid px-4">
                            <div className="d-flex align-items-center justify-content-between small">
                                <div className="text-muted">Copyright &copy; tms {new Date().getFullYear()}</div>
                                <div>
                                    <a href="#">Privacy Policy</a>
                                    &middot;
                                    <a href="#">Terms &amp; Conditions</a>
                                </div>
                            </div>
                        </div>
                    </footer>
                </div>
            </div>
        </>
    )
};

export default Layout;